import { useEffect, useRef, useState } from 'react'
import { MS_IN_SEC } from 'shared/constants'
import { getMsUntilUtcMidnight, getNextUtcMidnight } from 'shared/utils/utc-day'
import { useInterval } from './use-interval'

/**
 * Counts down to the next 00:00 UTC (daily tasks reset, demo coin top-up)
 * and calls `onReset` once each time that moment passes while mounted.
 * `msLeft` ticks every second; pass `isTicking: false` to read the reset
 * moment without re-rendering every second.
 */
export const useUtcDayReset = (
  onReset?: () => void,
  { isTicking = true }: { isTicking?: boolean } = {}
) => {
  const [now, setNow] = useState(Date.now)
  const nextResetRef = useRef(getNextUtcMidnight(now))
  const onResetRef = useRef(onReset)

  useEffect(() => {
    onResetRef.current = onReset
  }, [onReset])

  useInterval(() => {
    const current = Date.now()

    // NOTE: a tab asleep over midnight wakes past it; the reset runs once
    if (current >= nextResetRef.current) {
      nextResetRef.current = getNextUtcMidnight(current)
      onResetRef.current?.()
    }

    if (isTicking) setNow(current)
  }, MS_IN_SEC)

  return {
    msLeft: getMsUntilUtcMidnight(now),
    nextResetAt: nextResetRef.current
  }
}
